/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M0 3.6667C0 2.7462.8954 2 2 2h20c1.1046 0 2 .7462 2 1.6667v16.6666C24 21.2538 23.1046 22 22 22H2c-1.1046 0-2-.7462-2-1.6667V3.6667ZM2 3.25h20c.2761 0 .5.1865.5.4167v2.9166h-21V3.6667c0-.2302.2239-.4167.5-.4167Zm-.5 14.5833v2.5c0 .2302.2239.4167.5.4167h5.5v-2.9167h-6Zm14 2.9167H9v-2.9167h6.5V20.75Zm1.5 0h5c.2761 0 .5-.1865.5-.4167v-2.5H17V20.75Zm0-4.1667h5.5v-3.75H17v3.75Zm-1.5-3.75H9v3.75h6.5v-3.75Zm0-1.25H9v-3.75h6.5v3.75Zm1.5 0h5.5v-3.75H17v3.75Zm-15.5-3.75h6v3.75h-6v-3.75Zm6 8.75v-3.75h-6v3.75h6Z"
    clipRule="evenodd"
  />,
  'Table'
);
